import { Button, Tooltip } from 'antd'
import { RollbackOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUnarchiveCandidate } from '../hooks'

export function CandidateUnarchiveButton({ candidateId }: { candidateId: string }) {
    const { t } = useTranslation()
    const unarchive = useUnarchiveCandidate()

    return (
        <Tooltip title={t('Unarchive')}>
            <Button
                loading={unarchive.isPending}
                onClick={(event) => {
                    event.stopPropagation()

                    unarchive.mutate({
                        candidates: [candidateId],
                    })
                }}
                icon={<RollbackOutlined />}
            />
        </Tooltip>
    )
}
